import type { AppState } from 'state/state.model';

function getMonthlyExpiryCalendars(state: AppState) {
  return state.monthlyExpiryDates;
}

export function getUnknownMonthlyExpiryCalendars(state: AppState, calendarCodes: string[]): string[] {
  const knownMonthlyExpiryDatesCalendars = Object.keys(getMonthlyExpiryCalendars(state));
  return calendarCodes.filter(cal => !knownMonthlyExpiryDatesCalendars.includes(cal));
}
